module.exports = __webpack_public_path__ + "assets/checked-all.76401a42.svg";